import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportDeleteMohs } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';
import './MohView.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function MohView() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [mohData, setMohData] = useState(null);

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    
    const { user: { role } } = dataUser;
    if (dataUser && role !== 'root') return history.push('/home');

    if (!itemsSelectedToEdit) {
      return history.push('/config/musica-de-espera/lista');
    }

    try {
      // Em um cenário real, você buscaria os detalhes específicos desta música de espera
      // Aqui estamos simulando o carregamento dos dados
      setMohData({
        name: itemsSelectedToEdit,
        // Outros dados seriam carregados do servidor
      });
      setLoading(false);
    } catch (error) {
      console.error("Erro ao obter detalhes da música de espera:", error);
      history.push('/config/musica-de-espera/lista');
    }
  }, [history, itemsSelectedToEdit]);

  const handleDelete = () => {
    toggleIsHidden('#alert-confirm-delete');
  };

  const confirmDelete = async () => {
    try {
      const result = await exportDeleteMohs([mohData.name]);
      toggleIsHidden('#alert-confirm-delete');
      
      if (result && result.status === 200) {
        toggleIsHidden('#alert-success-deletion');
        setTimeout(() => {
          history.push('/config/musica-de-espera/lista');
        }, 3000);
      } else {
        toggleIsHidden('#alert-error-deletion');
      }
    } catch (error) {
      console.error("Erro ao excluir música de espera:", error);
      toggleIsHidden('#alert-confirm-delete');
      toggleIsHidden('#alert-error-deletion');
    }
  };

  const handleEdit = () => {
    history.push('/config/musica-de-espera/editar');
  };

  const handleBack = () => {
    history.push('/config/musica-de-espera/lista');
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  const formatDisplayName = (name) => {
    if (!name) return '';
    // Remover o prefixo "moh-" e a parte do tenant
    if (name.startsWith('moh-')) {
      const parts = name.substring(4).split('-');
      if (parts.length > 1) {
        return parts[0]; // Retorna apenas o nome sem o prefixo e o tenant
      }
    }
    return name;
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="moh-view-container">
          <div className="moh-view-header">
            <div className="moh-view-title-wrapper">
              <svg className="moh-view-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
              <div>
                <h1 className="moh-view-title">Detalhes da Música de Espera</h1>
                <p className="moh-view-subtitle">Visualize as informações da música de espera</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-error-deletion" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-error-deletion')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível excluir a música de espera.
              </div>
            </div>

            <div id="alert-success-deletion" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-success-deletion')}>×</button>
              </div>
              <div className="alert-body">
                Música de espera excluída com sucesso!
              </div>
            </div>

            <div id="alert-confirm-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-confirm-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que deseja excluir esta música de espera?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-alert-confirm" onClick={confirmDelete}>
                  <FontAwesomeIcon icon={faTrash} />
                  Confirmar
                </button>
                <button className="btn-alert btn-alert-cancel" onClick={() => toggleIsHidden('#alert-confirm-delete')}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>

          {mohData && (
            <div className="moh-details-card">
              <div className="details-section-title">Informações Básicas</div>
              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Nome</span>
                  <span className="detail-value">{formatDisplayName(mohData.name)}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Cliente</span>
                  <span className="detail-value">{mohData.accountcode || (mohData.name ? mohData.name.split('-').pop() : '')}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Modo</span>
                  <span className="detail-value">{mohData.mode === 'files' ? 'Ler Pasta' : mohData.mode === 'playlist' ? 'Música Única' : mohData.mode || '-'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Ordenação</span>
                  <span className="detail-value">{mohData.sort === 'name' ? 'Nome' : mohData.sort === 'random' ? 'Aleatório' : mohData.sort || '-'}</span>
                </div>
              </div>

              <div className="details-section-title">Localização</div>
              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Diretório</span>
                  <span className="detail-value">{mohData.directory || '-'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Arquivo</span>
                  <span className="detail-value">{mohData.entry || '-'}</span>
                </div>
              </div>
            </div>
          )}

          <div className="moh-actions">
            <Link to="/config/musica-de-espera/lista" className="btn-action btn-back">
              <FontAwesomeIcon icon={faArrowLeft} />
              Voltar
            </Link>
            <button className="btn-action btn-edit-view" onClick={handleEdit}>
              <FontAwesomeIcon icon={faPen} />
              Editar
            </button>
            <button className="btn-action btn-delete-view" onClick={handleDelete}>
              <FontAwesomeIcon icon={faTrash} />
              Excluir
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MohView; 